import useCounter from "./useCounter";
import jackpotBackground from "../assets/images/jackpot_background_en.png";

const HomeCounter = () => {
  const mini = useCounter(1513.58, 1000000);
  const grand = useCounter(107152.92, 1000000);
  const major = useCounter(12199.56, 1000000);
  return (
    <div className="jackpotImg-padding col col-12">
      <div
        className="v-image v-responsive position-relative theme--light"
        style={{ width: "100%" }}
      >
        <div
          className="v-responsive__sizer"
          style={{ "padding-bottom": "41.1765%" }}
        />
        <div
          className="v-image__image v-image__image--cover"
          style={{
             backgroundImage: `url(${jackpotBackground})`,
            "background-position": "center center",
          }}
        />
        <div className="v-responsive__content" style={{ width: "1020px" }}>
          <div className="jackpot_container">
            <div className="row justify-space-around align-end no-gutters">
              <div className="col col-3">
                <div
                  className="v-image v-responsive imgBox theme--light"
                  style={{ width: "100%" }}
                >
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "45.8333%" }}
                  />
                  <div
                    className="v-image__image v-image__image--cover"
                    style={{
                      "background-image":
                        'url("https://babu88.gold/static/image/homepage/mini_box.png")',
                      "background-position": "center center",
                    }}
                  />
                  <div
                    className="v-responsive__content"
                    style={{ width: "192px" }}
                  >
                    <span className="text-center white--text font-weight-bold miniText">
                      {mini.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col col-4">
                <div
                  className="v-image v-responsive imgBox theme--light"
                  style={{ width: "100%" }}
                >
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "41.6667%" }}
                  />
                  <div
                    className="v-image__image v-image__image--cover"
                    style={{
                      "background-image":
                        'url("https://babu88.gold/static/image/homepage/grand_box.png")',
                      "background-position": "center center",
                    }}
                  />
                  <div
                    className="v-responsive__content"
                    style={{ width: "240px" }}
                  >
                    <span className="text-center white--text grandText font-weight-bold">
                      {grand.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col col-3">
                <div
                  className="v-image v-responsive imgBox theme--light"
                  style={{ width: "100%" }}
                >
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "45.8333%" }}
                  />
                  <div
                    className="v-image__image v-image__image--cover"
                    style={{
                      "background-image":
                        'url("https://babu88.gold/static/image/homepage/major_box.png")',
                      "background-position": "center center",
                    }}
                  />
                  <div
                    className="v-responsive__content"
                    style={{ width: "192px" }}
                  >
                    <span className="text-center white--text font-weight-bold majorText">
                      {major.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeCounter;
